/** Whether a tag can be controlled from the Controller widget. */
export const CONTROLLABLE = {
  YES: 'YES',
  NO: 'NO',
} as const;

export type ControllableValue = (typeof CONTROLLABLE)[keyof typeof CONTROLLABLE];
